/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DepartmentsControllerUpdateMutationRequest, DepartmentsControllerUpdateMutationResponse, DepartmentsControllerUpdatePathParams, DepartmentsControllerUpdate400, DepartmentsControllerUpdate401, DepartmentsControllerUpdate403, DepartmentsControllerUpdate404 } from "../../models/departmentsController/DepartmentsControllerUpdate";

function getDepartmentsControllerUpdateUrl(id: DepartmentsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/departments/${id}` as const }  
  return res
}

/**
 * @summary Update a department
 * {@link /api/v1/departments/:id}
 */
export async function departmentsControllerUpdate(id: DepartmentsControllerUpdatePathParams["id"], data?: DepartmentsControllerUpdateMutationRequest, config: Partial<RequestConfig<DepartmentsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DepartmentsControllerUpdateMutationResponse, ResponseErrorConfig<DepartmentsControllerUpdate400 | DepartmentsControllerUpdate401 | DepartmentsControllerUpdate403 | DepartmentsControllerUpdate404>, DepartmentsControllerUpdateMutationRequest>({ method : "PATCH", url : getDepartmentsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}